import React from "react";

const TeacherContacts = ({teacher, tab}) => {
    return (
        <div>
            {
                tab == "contact" && (
                <div>
                    <div className="teacher-contact">
                        <p>
                            <strong>Institutional Email: </strong>
                            {teacher.contact.email}
                        </p>
                        <p>
                            <strong>Personal Email: </strong>
                            {teacher.contact.personal_email}
                        </p>
                        <p>
                            <strong>Phone: </strong>
                            {teacher.contact.phone}
                        </p>     
                        <p>
                            <strong>Mobile number: </strong>
                            {teacher.contact.mobile}
                        </p>      
                        <p>
                            <strong>PABX: </strong>
                            {teacher.contact.pabx}
                        </p>    
                        <p>&nbsp;</p>

                        {
                            teacher.contact.external_profiles.social && teacher.contact.external_profiles.social.length > 0 && (
                                <div>
                                <p className="sub-menu-header">Social profiles</p>
                                {
                                    teacher.contact.external_profiles.social.map((p) => (
                                    <a className="nw-flex-h" style={{margin: '1em 0', alignItems: 'center'}} href={p.url}>
                                        <img className="icon-round-medium" src={p.icon}></img>
                                        <span>{p.title}</span>
                                    </a>
                                    ))
                                }
                                </div>
                            )
                        }            
                    </div>

                    {/*
                    <h5 style={{textDecoration: 'underline'}}>Professional profiles</h5>
                    {
                        teacher.contact.external_profiles.professional?.map((p) => (
                            <a href={p.url}><div className="contact-external_profiles"></div></a> 
                        ))
                    }
                    */}
                </div>
                )
            }
            {
                tab == "offices" && (
                <div>
                    {
                        teacher.contact.offices && teacher.contact.offices.length > 0 && (
                            <div className="data-card-list">
                                {
                                    teacher.contact.offices.map((o) => (
                                        <div className="teacher-data-item data-card">
                                            <h3>{o.title}</h3>
                                            <p>
                                            {o.room && <span>Room: {o.room}</span>}
                                            {o.floor && <span>, {o.floor}</span> }
                                            </p>
                                            { o.building && <p>{o.building}</p> }
                                            {o.campus && <p>{o.campus}</p> }
                                            {o.office_hours && (
                                                <div className="office-hour-table">
                                                    <p className="table-header">Office hours:</p>
                                                    <p><span className="office-day">SUN</span><span>{o.office_hours.sun}</span></p>
                                                    <p><span className="office-day">MON</span></p>
                                                    <p><span className="office-day">TUE</span></p>
                                                    <p><span className="office-day">WED</span></p>
                                                    <p><span className="office-day">THU</span></p>
                                                </div>
                                            )
                                            }
                                        </div>
                                    ))
                                }
                            </div>
                        )
                    }
                    
                </div>
                )
            }
        </div>
    )
};

export default TeacherContacts;
